import { InjectionToken } from '@angular/core';
import { SelfFixConfig } from '../models/config/self-fix-config.interface';

export const SELF_FIX_CONFIG = new InjectionToken<SelfFixConfig>(
  'self fix config'
);
